import React from 'react';
import PropTypes from 'prop-types';
import cIf from 'classnames';
import createClass from 'create-react-class';
const tr = require('ts-translate-js').default.boundTR;

export const DISPLAY_SAM = createClass({
    displayName: "DISPLAY_SAM",

    PropTypes: {
        ready: PropTypes.bool,
        cartUrl: PropTypes.string,
        cartExpired: PropTypes.bool,
        productCount: PropTypes.number,
        remainingTimeString: PropTypes.string,
        displayTime: PropTypes.bool,
        expiresSoon: PropTypes.bool,
        showLogout: PropTypes.bool,
        onLogoutClick: PropTypes.func
    },

    getInitialState: function () {
        return {
            windowSize: { width: 0, height: 0 } // We hide some of the things when the screen is too small
        };
    },


    componentDidMount() {
        this.setState({ windowSize: { width: window.ComBridge_InfoCache.windowSize.width, height: window.ComBridge_InfoCache.windowSize.height }});

        if(typeof(window.ComBridge_InfoCache) != "undefined") {
            tsapp.integrationEventsEmitter.on('onWindowSizeChanged', (windowSize) => { this.handleNewWindowSize(windowSize); });
        }
    },

    handleNewWindowSize(size) {
        this.setState({ windowSize: {
            width: size.width,
            height: size.height
        }});
    },

    render(){
        if (!this.props.ready)
            return <span></span>;
        
        const screenTooSmallForLogout = this.state.windowSize.width < 450;
        let timeLabel;
        let logoutLink;
        let productCountLabel;

        if(this.props.productCount > 0) {
            timeLabel = <div className={cIf([ "time", { expiressoon:this.props.expiresSoon, flash: this.props.expiresSoon && this.props.displayTime } ])}><div>{this.props.remainingTimeString}</div></div>;
            productCountLabel = <div className="product-count">{this.props.productCount}</div>;
        } else {
            if(this.props.cartExpired)
                timeLabel = <div className="time elapsed"><div>{tr("cartwidget.timeelapsed")}</div></div>;
            productCountLabel = <div className="product-count no-item">0</div>;
        }


        if(this.props.showLogout && !screenTooSmallForLogout)
            logoutLink =
                //TODO: Refactor this as a button
                // eslint-disable-next-line sonarjs/anchor-is-valid
                <a href="#" className="logout" title={tr("Fermer la session")} onClick={this.props.onLogoutClick}>
                    <div className="icon"></div>
                </a>;
    

        return (
            <div className="cart-status-control cart-status-control-display2">

                {/* Be careful with what you use here becasue this controle MUST defines its own width according
                    to it's content since the width is sent the the frame owner and then resized accordingly  */}
                <ul>

                    <li>
                        <div className="cart-status-box">
                            {/* TODO: Refactor this as a button */}
                            {/* eslint-disable-next-line sonarjs/anchor-is-valid */}
                            <a onClick={this.props.onCartClick} onKeyDown={(e) => { if (e.key === 'Enter') this.props.onCartClick(e); }} target="_top">
                                <div className={cIf([ "cart-link-box", { elapsed: this.props.cartExpired } ])}>
                                    <div className="cart-link">
                                        {productCountLabel}
                                    </div>
                                </div>
                                {timeLabel}
                            </a>
                        </div>
                    </li>

                    {logoutLink != null
                        ? <li>{logoutLink}</li>
                        : null}
                </ul>

            </div>
        );
    }
});